var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusWaitlisted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95533 2.04468C11.9669 2.55229 14.116 5.24222 13.9461 8.29159C13.7761 11.3409 11.3416 13.7755 8.29224 13.9454C5.24288 14.1153 2.55295 11.9663 2.04533 8.95468",
    stroke: "#EA180C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04466 6.9553C2.10703 6.58378 2.20458 6.21903 2.33599 5.86597",
    stroke: "#EA180C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13133 3.33203C3.84016 3.57254 3.57251 3.84019 3.332 4.13136",
    stroke: "#EA180C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95533 2.04476C6.58377 2.10727 6.21901 2.20504 5.866 2.33676",
    stroke: "#EA180C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 8.33341H8.33333V4.66675",
    stroke: "#EA180C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusWaitlisted);
export default __webpack_public_path__ + "static/media/status-waitlisted.4515ffde255ce888c4b2164b88a3b75f.svg";
export { ForwardRef as ReactComponent };